import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";

export const RedButton = styled(Button)(({ theme }) => ({
  color: "#FFF",
  fontFamily: "var(--font-family)",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: "600",
  backgroundColor: "var(--primary-color)",
  "&:hover": {
    backgroundColor: "var(--primary-color-hover)",
  },
}));
